import LocalEvaluator from "../../../../mode/local/LocalEvaluator"
import { EvaluatorContext } from "../../../../evaluator/Evaluator"
import EvaluateRequest from "../../../../EvaluateRequest"
import RemoteConfigLocalEvaluateRequest from "./RemoteConfigLocalEvaluateRequest"
import RemoteConfigEvaluateResponse from "../../RemoteConfigEvaluateResponse"
import RemoteConfigEvaluateResult from "../../RemoteConfigEvaluateResult"
import RemoteConfigParameterTargetRuleDeterminer from "../../match/RemoteConfigParameterTargetRuleDeterminer"
import { DecisionReason } from "../../../../../model/model"
import ObjectUtil from "../../../../../util/ObjectUtil"
import EvaluationEventRecorder from "../../../../event/EvaluationEventRecorder"
import RemoteConfigEvaluator from "../../RemoteConfigEvaluator"

export default class RemoteConfigLocalEvaluator
  extends LocalEvaluator<RemoteConfigLocalEvaluateRequest, RemoteConfigEvaluateResponse>
  implements RemoteConfigEvaluator<RemoteConfigLocalEvaluateRequest>
{
  constructor(
    private readonly targetRuleDeterminer: RemoteConfigParameterTargetRuleDeterminer,
    private readonly eventRecorder: EvaluationEventRecorder
  ) {
    super()
  }

  supports(request: EvaluateRequest): request is RemoteConfigLocalEvaluateRequest {
    return request instanceof RemoteConfigLocalEvaluateRequest
  }

  protected doEvaluate(
    request: RemoteConfigLocalEvaluateRequest,
    context: EvaluatorContext
  ): RemoteConfigEvaluateResponse {
    if (ObjectUtil.isNullOrUndefined(request.user.identifiers[request.entity.identifierType])) {
      const result = RemoteConfigEvaluateResult.fromRequest(request, DecisionReason.IDENTIFIER_NOT_FOUND, undefined)
      return RemoteConfigEvaluateResponse.of(request, context, result)
    }

    const targetRule = this.targetRuleDeterminer.determineTargetRuleOrNull(request, context)
    if (ObjectUtil.isNullOrUndefined(targetRule)) {
      const result = RemoteConfigEvaluateResult.fromRequest(
        request,
        DecisionReason.DEFAULT_RULE,
        request.entity.defaultValue
      )
      return RemoteConfigEvaluateResponse.of(request, context, result)
    }

    const result = RemoteConfigEvaluateResult.fromRequest(request, DecisionReason.TARGET_RULE_MATCH, targetRule.value)
    return RemoteConfigEvaluateResponse.of(request, context, result)
  }

  record(_request: RemoteConfigLocalEvaluateRequest, response: RemoteConfigEvaluateResponse): void {
    this.eventRecorder.record(response)
  }
}
